/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CheckGiftHandleResponse, CheckGiftHandleVars } from '../openapi-types.gen.js';

export type { CheckGiftHandleResponse, CheckGiftHandleVars } from '../openapi-types.gen.js';

export const useCheckGiftHandle = createMutationHook<CheckGiftHandleVars, CheckGiftHandleResponse, unknown>({
  specName: 'useCheckGiftHandle',
  path: '/v1/gifts/handle-check',
  method: 'POST',
  resolveUrl: (vars: CheckGiftHandleVars) => `/v1/gifts/handle-check`,
  buildBody: (vars: CheckGiftHandleVars) => ({ handle: vars.handle }),
  parseResponse: (raw: unknown): CheckGiftHandleResponse => raw as CheckGiftHandleResponse,
  
  
  
});
